import { __extends } from "tslib";
import config from '../config';
import Flow from './Flow';
var SelectShop = /*@__PURE__*/ (function (_super) {
    __extends(SelectShop, _super);
    function SelectShop() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.init = function () {
            _this.setRoamingStepperItem(config.appointman.flow.SELECT_SHOP);
            if (_this.getState().CURRENT_FLOW === config.appointman.flow.SELECT_SHOP) {
                // redirect to shopfinder
            }
            _this.getItem().setComplete(true);
            _this.getItem().setLabel(_this.buildPreviewLabel());
            _this.rmsID = _this.getState().rmsID;
            _this.getItem().onChangeRequest(function () {
                window.location.href = config.appointman.api.SHOPFINDER_URI;
            });
            if (_this.getState().apmID) {
                _this.getItem().disableChangeHandle();
            }
        };
        return _this;
    }
    SelectShop.prototype.onStateChange = function () {
        if (this.getState().rmsID !== this.rmsID) {
            this.rmsID = this.getState().rmsID;
            this.getItem().setComplete(true);
            this.getItem().setLabel(this.buildPreviewLabel());
        }
        if (this.getState().apmID) {
            this.getItem().disableChangeHandle();
        }
    };
    SelectShop.prototype.onNextRequest = function () {
    };
    SelectShop.prototype.buildPreviewLabel = function () {
        var html = SelectShop.PREVIEW_LABEL_HTML;
        var value = '';
        if (this.getState().distance) {
            value = this.getState().shopInfo.street + " / " + this.getState().distance + " km";
        }
        else {
            value = "" + this.getState().shopInfo.street;
        }
        html = html.replace('%s', value);
        return html;
    };
    SelectShop.PREVIEW_LABEL_HTML = config.appointman.msg.SELECT_SHOP_PREVIEW;
    return SelectShop;
}(Flow));
export default SelectShop;



//////////////////
// WEBPACK FOOTER
// ./app/bundles/appointman/app/ts/flow/SelectShop.ts
// module id = null
// module chunks = 